

import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Switch, withRouter, Redirect } from 'react-router-dom';
import moment from 'moment';



import PrivateRoute from 'jsx/auth/PrivateRoute';
import Root from 'jsx/layout/Root';
// import Modal from 'jsx/elements/modals/Modal';
import { loadProducts } from 'jsx/layout/Header/ducks';
import { loadSharedProducts } from 'jsx/layout/Sidebar/ducks';

import { TOP_MENU } from './constants/products';

import Calculation from './pages/Calculation';
import ClaimTracker from './pages/ClaimTracker';
import UserMenu from './pages/UserMenu';


require('json.date-extensions');
JSON.useDateParser();


class App extends React.Component {

  componentDidMount() {
    moment.locale('is');
    this.props.loadProducts(TOP_MENU);
    this.props.loadSharedProducts();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.locale.loaded) {
      document.getElementsByTagName('html')[0].classList.remove('init-app');
    }
  }

//<PrivateRoute exact path="/claimtracker" component={ClaimTracker} />

  render() {
    return (
      <Root user={this.props.user.name} userSub={this.props.user.s_name} UserMenu={UserMenu}>
        <Switch>
          <PrivateRoute
            exact
            path="/"
            render={() => <Redirect to={{ pathname: '/dashboard' }} />}
          />
          <PrivateRoute exact path="/calculation" component={Calculation} />          
          <PrivateRoute render={() => <Redirect to={{ pathname: '/calculation' }} />} />
        </Switch>
      </Root>
    );
  }
}

App.propTypes = {
  user: PropTypes.object.isRequired,
  userManager: PropTypes.object.isRequired,
  navigation: PropTypes.array.isRequired
};

const mapState = ({ locale }) => ({ locale });
const mapDispatch = dispatch => ({
  loadProducts: bindActionCreators(loadProducts, dispatch),
  loadSharedProducts: bindActionCreators(loadSharedProducts, dispatch)
});

export default withRouter(connect(mapState, mapDispatch)(App));






// WEBPACK FOOTER //
// ./src/App.js